import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { fetchPvInverterList } from '../api/solar.api'
import { PvInverterModel } from '../models/solar.model'
import { usePortalQuery } from 'src/Libs/api'

const usePvInverterList = (storageId?: string): [PvInverterModel[] | null, boolean, boolean] => {
  const authFetch = useAuthFetchWithResponse()

  const { data, isLoading, isError } = usePortalQuery({
    queryKey: ['pv-inverter-list', storageId],
    queryFn: () => fetchPvInverterList(storageId, authFetch),
    enabled: !!storageId,
    select: data => data ?? null,
  })

  return [data || null, isLoading, isError]
}

export default usePvInverterList
